module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0276-2-min.ddccc42d.jpg";